import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads functional usage when the current record's room type changes. The
 * backend may adjust functional usage as a side effect of a room type change
 * (e.g. switching to Manual after the room type changes from Lab Service to
 * Standard), so this ensures the record immediately reflects that, without
 * requiring a page refresh.
 */
export const loadForCurrentEntityOnRoomTypeChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asObservable.pipe(
        rxjs.pairwise(),
        rxjs.filter(
          ([previous, current]) =>
            previous !== undefined &&
            current !== undefined &&
            previous.id === current.id &&
            previous.roomTypeId !== current.roomTypeId,
        ),
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load for current entity on room type change')
            .create(),
        ),
      ),
)
